export default "/images/currency-euro.svg?3290feee4321f4650e5e0779c48abdce";